import { useCallback, useEffect, useState } from 'react';
export default function useFocusedElement() {
    const [focusedElement, setFocusedElement] = useState(window.document.activeElement);
    // handles situation where a new element gets the focus
    const handleFocusChange = useCallback((focusInEvent) => {
        if (focusInEvent.target instanceof Element) {
            setFocusedElement(focusInEvent.target);
        }
    }, []);
    // handles situation where an element loses the focus,
    // and no other element gets it
    const handleBlur = useCallback((focusOutEvent) => {
        if (focusOutEvent.relatedTarget === null) {
            setFocusedElement(null);
        }
    }, []);
    useEffect(() => {
        window.document.body.addEventListener('focusin', handleFocusChange);
        window.document.body.addEventListener('focusout', handleBlur);
        return () => {
            window.document.body.removeEventListener('focusin', handleFocusChange);
            window.document.body.removeEventListener('focusout', handleBlur);
        };
    }, [handleFocusChange, handleBlur]);
    return focusedElement;
}
//# sourceMappingURL=useFocusedElement.js.map